// src/pages/manager/LoungeDiscountManager.jsx
import React from 'react';
import OrderDiscountManager from '../MenuItemList';

const LoungeDiscountManager = () => {
  return <OrderDiscountManager locationKey="lounge" />;
};

export default LoungeDiscountManager;